// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Scalar from "../../core/Scalar.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query OrderQuery($id: ID!)  {\norder(id: $id)  {\n__typename  \nid  \nupdatedAt  \nformattedName  \nformattedStatus  \ncart  \nnote  \ncondition  \nnoteForSupplier  \nsupplier  {\n__typename  \nid  \ncompanyName  \nlocations  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \naddress  \npostalCode  \ncity  \ncountry  \n}\n\n}\n\n}\n\n}\n\nissueDate  \nestimatedReceptionDate  \nreceptionFinishedAt  \nshop  {\n__typename  \nid  \n}\n\ndevice  {\n__typename  \nid  \n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.order;
  let tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    let value$2 = value$1.formattedStatus;
    let value$3 = value$1.note;
    let value$4 = value$1.condition;
    let value$5 = value$1.noteForSupplier;
    let value$6 = value$1.supplier;
    let tmp$1;
    if (value$6 == null) {
      tmp$1 = undefined;
    } else {
      let value$7 = value$6.locations;
      let value$8 = value$7.edges;
      tmp$1 = {
        __typename: value$6.__typename,
        id: value$6.id,
        companyName: value$6.companyName,
        locations: {
          __typename: value$7.__typename,
          edges: value$8.map(value => {
            let value$1 = value.node;
            let value$2 = value$1.address;
            let value$3 = value$1.postalCode;
            let value$4 = value$1.city;
            let value$5 = value$1.country;
            return {
              __typename: value.__typename,
              node: {
                __typename: value$1.__typename,
                address: !(value$2 == null) ? value$2 : undefined,
                postalCode: !(value$3 == null) ? value$3 : undefined,
                city: !(value$4 == null) ? value$4 : undefined,
                country: !(value$5 == null) ? value$5 : undefined
              }
            };
          })
        }
      };
    }
    let value$9 = value$1.receptionFinishedAt;
    let value$10 = value$1.shop;
    let value$11 = value$1.device;
    tmp = {
      __typename: value$1.__typename,
      id: value$1.id,
      updatedAt: Scalar.Datetime.parse(value$1.updatedAt),
      formattedName: value$1.formattedName,
      formattedStatus: value$2.map(value => {
        switch (value) {
          case "ACCEPTED" :
            return "ACCEPTED";
          case "ARCHIVED" :
            return "ARCHIVED";
          case "DRAFT" :
            return "DRAFT";
          case "FINALIZED" :
            return "FINALIZED";
          case "NOT_RECEIVED" :
            return "NOT_RECEIVED";
          case "PAID" :
            return "PAID";
          case "RECEIVED" :
            return "RECEIVED";
          case "RECEIVING" :
            return "RECEIVING";
          case "REFUSED" :
            return "REFUSED";
          case "SENT" :
            return "SENT";
          case "TO_PAY" :
            return "TO_PAY";
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
      }),
      cart: Scalar.Text.parse(value$1.cart),
      note: !(value$3 == null) ? Scalar.Text.parse(value$3) : undefined,
      condition: !(value$4 == null) ? Scalar.Text.parse(value$4) : undefined,
      noteForSupplier: !(value$5 == null) ? Scalar.Text.parse(value$5) : undefined,
      supplier: tmp$1,
      issueDate: Scalar.Datetime.parse(value$1.issueDate),
      estimatedReceptionDate: Scalar.Datetime.parse(value$1.estimatedReceptionDate),
      receptionFinishedAt: !(value$9 == null) ? Scalar.Datetime.parse(value$9) : undefined,
      shop: {
        __typename: value$10.__typename,
        id: value$10.id
      },
      device: {
        __typename: value$11.__typename,
        id: value$11.id
      }
    };
  }
  return {
    order: tmp
  };
}

function serialize(value) {
  let value$1 = value.order;
  let order;
  if (value$1 !== undefined) {
    let value$2 = value$1.device;
    let value$3 = value$2.id;
    let value$4 = value$2.__typename;
    let device = {
      __typename: value$4,
      id: value$3
    };
    let value$5 = value$1.shop;
    let value$6 = value$5.id;
    let value$7 = value$5.__typename;
    let shop = {
      __typename: value$7,
      id: value$6
    };
    let value$8 = value$1.receptionFinishedAt;
    let receptionFinishedAt = value$8 !== undefined ? Scalar.Datetime.serialize(value$8) : null;
    let value$9 = value$1.estimatedReceptionDate;
    let value$10 = Scalar.Datetime.serialize(value$9);
    let value$11 = value$1.issueDate;
    let value$12 = Scalar.Datetime.serialize(value$11);
    let value$13 = value$1.supplier;
    let supplier;
    if (value$13 !== undefined) {
      let value$14 = value$13.locations;
      let value$15 = value$14.edges;
      let edges = value$15.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.country;
        let country = value$2 !== undefined ? value$2 : null;
        let value$3 = value$1.city;
        let city = value$3 !== undefined ? value$3 : null;
        let value$4 = value$1.postalCode;
        let postalCode = value$4 !== undefined ? value$4 : null;
        let value$5 = value$1.address;
        let address = value$5 !== undefined ? value$5 : null;
        let value$6 = value$1.__typename;
        let node = {
          __typename: value$6,
          address: address,
          postalCode: postalCode,
          city: city,
          country: country
        };
        let value$7 = value.__typename;
        return {
          __typename: value$7,
          node: node
        };
      });
      let value$16 = value$14.__typename;
      let locations = {
        __typename: value$16,
        edges: edges
      };
      let value$17 = value$13.companyName;
      let value$18 = value$13.id;
      let value$19 = value$13.__typename;
      supplier = {
        __typename: value$19,
        id: value$18,
        companyName: value$17,
        locations: locations
      };
    } else {
      supplier = null;
    }
    let value$20 = value$1.noteForSupplier;
    let noteForSupplier = value$20 !== undefined ? Scalar.Text.serialize(value$20) : null;
    let value$21 = value$1.condition;
    let condition = value$21 !== undefined ? Scalar.Text.serialize(value$21) : null;
    let value$22 = value$1.note;
    let note = value$22 !== undefined ? Scalar.Text.serialize(value$22) : null;
    let value$23 = value$1.cart;
    let value$24 = Scalar.Text.serialize(value$23);
    let value$25 = value$1.formattedStatus;
    let formattedStatus = value$25.map(value => {
      if (value === "TO_PAY") {
        return "TO_PAY";
      } else if (value === "DRAFT") {
        return "DRAFT";
      } else if (value === "NOT_RECEIVED") {
        return "NOT_RECEIVED";
      } else if (value === "REFUSED") {
        return "REFUSED";
      } else if (value === "FINALIZED") {
        return "FINALIZED";
      } else if (value === "ACCEPTED") {
        return "ACCEPTED";
      } else if (value === "PAID") {
        return "PAID";
      } else if (value === "RECEIVING") {
        return "RECEIVING";
      } else if (value === "SENT") {
        return "SENT";
      } else if (value === "RECEIVED") {
        return "RECEIVED";
      } else {
        return "ARCHIVED";
      }
    });
    let value$26 = value$1.formattedName;
    let value$27 = value$1.updatedAt;
    let value$28 = Scalar.Datetime.serialize(value$27);
    let value$29 = value$1.id;
    let value$30 = value$1.__typename;
    order = {
      __typename: value$30,
      id: value$29,
      updatedAt: value$28,
      formattedName: value$26,
      formattedStatus: formattedStatus,
      cart: value$24,
      note: note,
      condition: condition,
      noteForSupplier: noteForSupplier,
      supplier: supplier,
      issueDate: value$12,
      estimatedReceptionDate: value$10,
      receptionFinishedAt: receptionFinishedAt,
      shop: shop,
      device: device
    };
  } else {
    order = null;
  }
  return {
    order: order
  };
}

function serializeVariables(inp) {
  return {
    id: inp.id
  };
}

function makeVariables(id, param) {
  return {
    id: id
  };
}

let OrderQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let OrderQuery_refetchQueryDescription = include.refetchQueryDescription;

let OrderQuery_use = include.use;

let OrderQuery_useLazy = include.useLazy;

let OrderQuery_useLazyWithVariables = include.useLazyWithVariables;

let OrderQuery = {
  OrderQuery_inner: OrderQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  refetchQueryDescription: OrderQuery_refetchQueryDescription,
  use: OrderQuery_use,
  useLazy: OrderQuery_useLazy,
  useLazyWithVariables: OrderQuery_useLazyWithVariables
};

let Raw$1 = {};

let query$1 = Client.gql(["query OrderVariantsStockQuery($id: ID!, $first: Int, $after: String)  {\norder(id: $id)  {\n__typename  \nproducts(first: $first, after: $after)  {\n__typename  \npageInfo  {\n__typename  \nendCursor  \nhasNextPage  \n}\n\nedges  {\n__typename  \nnode  {\n__typename  \nid  \nvariant  {\n__typename  \nstock  {\n__typename  \nrawQuantity  \n}\n\n}\n\n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse$1(value) {
  let value$1 = value.order;
  let tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    let value$2 = value$1.products;
    let value$3 = value$2.pageInfo;
    let value$4 = value$3.endCursor;
    let value$5 = value$3.hasNextPage;
    let value$6 = value$2.edges;
    tmp = {
      __typename: value$1.__typename,
      products: {
        __typename: value$2.__typename,
        pageInfo: {
          __typename: value$3.__typename,
          endCursor: !(value$4 == null) ? value$4 : undefined,
          hasNextPage: !(value$5 == null) ? value$5 : undefined
        },
        edges: value$6.map(value => {
          let value$1 = value.node;
          let value$2 = value$1.variant;
          let tmp;
          if (value$2 == null) {
            tmp = undefined;
          } else {
            let value$3 = value$2.stock;
            let value$4 = value$3.rawQuantity;
            tmp = {
              __typename: value$2.__typename,
              stock: {
                __typename: value$3.__typename,
                rawQuantity: !(value$4 == null) ? value$4 : undefined
              }
            };
          }
          return {
            __typename: value.__typename,
            node: {
              __typename: value$1.__typename,
              id: value$1.id,
              variant: tmp
            }
          };
        })
      }
    };
  }
  return {
    order: tmp
  };
}

function serialize$1(value) {
  let value$1 = value.order;
  let order;
  if (value$1 !== undefined) {
    let value$2 = value$1.products;
    let value$3 = value$2.edges;
    let edges = value$3.map(value => {
      let value$1 = value.node;
      let value$2 = value$1.variant;
      let variant;
      if (value$2 !== undefined) {
        let value$3 = value$2.stock;
        let value$4 = value$3.rawQuantity;
        let rawQuantity = value$4 !== undefined ? value$4 : null;
        let value$5 = value$3.__typename;
        let stock = {
          __typename: value$5,
          rawQuantity: rawQuantity
        };
        let value$6 = value$2.__typename;
        variant = {
          __typename: value$6,
          stock: stock
        };
      } else {
        variant = null;
      }
      let value$7 = value$1.id;
      let value$8 = value$1.__typename;
      let node = {
        __typename: value$8,
        id: value$7,
        variant: variant
      };
      let value$9 = value.__typename;
      return {
        __typename: value$9,
        node: node
      };
    });
    let value$4 = value$2.pageInfo;
    let value$5 = value$4.hasNextPage;
    let hasNextPage = value$5 !== undefined ? value$5 : null;
    let value$6 = value$4.endCursor;
    let endCursor = value$6 !== undefined ? value$6 : null;
    let value$7 = value$4.__typename;
    let pageInfo = {
      __typename: value$7,
      endCursor: endCursor,
      hasNextPage: hasNextPage
    };
    let value$8 = value$2.__typename;
    let products = {
      __typename: value$8,
      pageInfo: pageInfo,
      edges: edges
    };
    let value$9 = value$1.__typename;
    order = {
      __typename: value$9,
      products: products
    };
  } else {
    order = null;
  }
  return {
    order: order
  };
}

function serializeVariables$1(inp) {
  let a = inp.first;
  let a$1 = inp.after;
  return {
    id: inp.id,
    first: a !== undefined ? a : undefined,
    after: a$1 !== undefined ? a$1 : undefined
  };
}

function makeVariables$1(id, first, after, param) {
  return {
    id: id,
    first: first,
    after: after
  };
}

let OrderVariantsStockQuery_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1
};

let include$1 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1
});

let use = include$1.use;

let OrderVariantsStockQuery_refetchQueryDescription = include$1.refetchQueryDescription;

let OrderVariantsStockQuery_useLazy = include$1.useLazy;

let OrderVariantsStockQuery_useLazyWithVariables = include$1.useLazyWithVariables;

let OrderVariantsStockQuery = {
  OrderVariantsStockQuery_inner: OrderVariantsStockQuery_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1,
  refetchQueryDescription: OrderVariantsStockQuery_refetchQueryDescription,
  use: use,
  useLazy: OrderVariantsStockQuery_useLazy,
  useLazyWithVariables: OrderVariantsStockQuery_useLazyWithVariables
};

function use$1(skip, ready, id) {
  let terminated = React.useRef(false);
  React.useEffect(() => {
    if (ready && skip) {
      terminated.current = true;
    }
  }, [
    ready,
    skip
  ]);
  let query = use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, terminated.current || ready ? skip : true, undefined, {
    id: Stdlib_Option.getOr(id, ""),
    first: 5,
    after: undefined
  });
  let match = query.data;
  if (match !== undefined) {
    let order = match.order;
    if (order !== undefined && query.networkStatus === "Ready") {
      let match$1 = order.products.pageInfo.endCursor;
      let match$2 = order.products.pageInfo.hasNextPage;
      let exit = 0;
      if (match$1 !== undefined) {
        if (match$2 !== undefined) {
          if (match$2) {
            query.fetchMore(undefined, undefined, {
              id: Stdlib_Option.getOr(id, ""),
              first: 5,
              after: match$1
            }, (prevResult, param) => {
              let fetchMoreResult = param.fetchMoreResult;
              let prevOrder = prevResult.order;
              if (prevOrder === undefined) {
                return prevResult;
              }
              if (fetchMoreResult === undefined) {
                return prevResult;
              }
              let newOrder = fetchMoreResult.order;
              if (newOrder === undefined) {
                return prevResult;
              }
              let init = newOrder.products;
              return {
                order: {
                  __typename: newOrder.__typename,
                  products: {
                    __typename: init.__typename,
                    pageInfo: init.pageInfo,
                    edges: Belt_Array.concatMany([
                      prevOrder.products.edges,
                      newOrder.products.edges
                    ])
                  }
                }
              };
            }, undefined);
          } else {
            exit = 1;
          }
        }
      } else {
        exit = 1;
      }
      if (exit === 1) {
        if (match$2 !== undefined && !match$2) {
          terminated.current = true;
        }
      }
    }
  }
  let match$3 = query.networkStatus;
  let match$4 = terminated.current;
  let tmp;
  tmp = match$3 === "Loading" && match$4 ? "Ready" : query.networkStatus;
  return {
    called: query.called,
    client: query.client,
    data: query.data,
    previousData: query.previousData,
    error: query.error,
    loading: !terminated.current,
    networkStatus: tmp,
    fetchMore: query.fetchMore,
    refetch: query.refetch,
    startPolling: query.startPolling,
    stopPolling: query.stopPolling,
    subscribeToMore: query.subscribeToMore,
    updateQuery: query.updateQuery
  };
}

let OrderVariantsStockQueryHook = {
  use: use$1
};

export {
  OrderQuery,
  OrderVariantsStockQuery,
  OrderVariantsStockQueryHook,
}
/* query Not a pure module */
